export class Photo {
  constructor(props = {}) {
    this.id = props.id
    this.sort = props.sort || 1
    this.displayType = props.displayType || 0
    this.title = props.title || ''
    this.comment = props.comment || ''
    this.tmpFileId = props.tmpFileId
    this.toDelete = false
    this.mime = props.mime
  }

  export() {
    return {
      id: this.id,
      sort: this.sort,
      displayType: this.displayType,
      title: this.title,
      comment: this.comment,
      tmpFileId: this.tmpFileId,
    }
  }
}
